const rootGalleryId = (artistId: string) => `${artistId}~ROOT`;

export { rootGalleryId };
